// extracted by mini-css-extract-plugin
export default {"actKc2Title":"ActKc2Title_actKc2Title__uFow6","title":"ActKc2Title_title__CH0Bh","titleInactive":"ActKc2Title_titleInactive__siZi8"};